import React from 'react';
import axios from 'axios';

import { apiEndpoint } from 'config/track-config';
import { CalculatedDelivery } from 'models/shipments';

import { useCurrentArticle } from '../../../../hooks/shipment.hooks';
import { SearchResult } from '../CalculatorModals/AddressLookupModal';

export enum ErrorType {
  NO_CONTENT = 'no content',
  SERVER_ERROR = 'server error',
}

const apiGetInlineEdd = (trackingId: string, postcode: string, suburb?: string) => {
  const _shipmentEddUrl = `${apiEndpoint.shipmentEdd}/${trackingId}`;

  const requestConfig = {
    headers: {
      'Content-Type': 'application/json',
      'AUTH-KEY': apiEndpoint.apiKeys.eddAPI,
    },
    withCredentials: true,
    params: {
      postcode,
      suburb,
    },
  };

  return axios.get(_shipmentEddUrl, requestConfig);
};

export const useInlineEddCalculator = () => {
  const trackingId = useCurrentArticle().articleId;
  const [estimate, setEstimate] = React.useState<CalculatedDelivery | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorType, setErrorType] = React.useState<ErrorType | null>(null);

  async function fetchEstimate(query: SearchResult | null) {
    if (!query?.postcode || !trackingId) return;

    setIsLoading(true);
    setErrorType(null);
    setEstimate(null);

    let res;
    const { postcode, suburb } = query;
    try {
      res = await apiGetInlineEdd(trackingId, postcode, suburb);
    } catch (err) {
      setErrorType(ErrorType.SERVER_ERROR);
    }
    setIsLoading(false);
    if (res?.status === 204) return setErrorType(ErrorType.NO_CONTENT);
    const estimatedDelivery = res?.data?.articles[0]?.estimatedDelivery;
    if (estimatedDelivery) return setEstimate(estimatedDelivery);
    return setErrorType(ErrorType.SERVER_ERROR);
  }

  return { isLoading, calculatedDeliveryEstimate: estimate, errorType, fetchEstimate };
};
